import type {
  CreateEstablishmentDTO,
  Establishment,
  JeridSchoolAdminDashboard,
  SuperAdmin,
  UpdateEstablishmentDTO,
} from '@/interface/types'
import { api } from '../axios-instance'

export const jeridSchoolAdminService = {
  getDashboard: async () => {
    const response = await api.get<JeridSchoolAdminDashboard>(
      '/jerid-school-admin/dashboard',
    )
    return response.data
  },

  getSchoolDirectors: async () => {
    const response = await api.get<SuperAdmin[]>(
      '/jerid-school-admin/school-directors',
    )
    return response.data
  },

  getEstablishments: async () => {
    const response = await api.get<Establishment[]>(
      '/jerid-school-admin/establishments',
    )
    return response.data
  },

  createEstablishment: async (data: CreateEstablishmentDTO) => {
    const response = await api.post<Establishment>(
      '/jerid-school-admin/establishments',
      data,
    )
    return response.data
  },

  updateEstablishment: async (id: string, data: UpdateEstablishmentDTO) => {
    const response = await api.patch<Establishment>(
      `/jerid-school-admin/establishments/${id}`,
      data,
    )
    return response.data
  },

  activateEstablishment: async (id: string) => {
    const response = await api.patch<Establishment>(
      `/jerid-school-admin/establishments/${id}/activate`,
    )
    return response.data
  },

  deactivateEstablishment: async (id: string) => {
    const response = await api.patch<Establishment>(
      `/jerid-school-admin/establishments/${id}/deactivate`,
    )
    return response.data
  },

  deleteEstablishment: async (id: string) => {
    await api.delete(`/jerid-school-admin/establishments/${id}`)
  },
}
